import {
  DATA_TABLE_PAGE_SIZE_KEY,
  PAGE_SIZE,
  PAGE_SIZES,
} from '../models/data-table-settings';
import { parseLocalStorageItem } from './parse-local-storage-item';

/**
 * Get the saved page size in local storage or the default value if it does not exist
 */
export const getSavedPageSize = () => {
  const pageSize = parseLocalStorageItem<number>(DATA_TABLE_PAGE_SIZE_KEY);

  if (pageSize === null || !PAGE_SIZES.includes(pageSize)) {
    return PAGE_SIZE;
  }

  return pageSize;
};
